import { ChatterSortOrder } from './types';

export const CHATTER_AUDIENCES = ['The LuxGroup Only', 'All with access'];

export const CHATTER_EDITOR_PLACEHOLDER = 'Share an update...';

export const CHATTER_SORT_OPTIONS: Array<{ value: ChatterSortOrder; label: string }> = [
  { value: 'activity', label: 'Most Recent Activity' },
  { value: 'latest', label: 'Latest Posts' },
];

export const CHATTER_ATTACHMENT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.png,.jpg,.jpeg,.gif';
